import {
    type FC,
    type MouseEvent,
    useEffect,
    useState,
} from "react";
import { Icon, useMediaQuery } from "@onshopfront/components";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { showDialog } from "../../Actions/Dialogs/DialogActions";
import { HelpPage } from "../../Common/HelpPage/HelpPage";
import { useHelpManager } from "../../Utilities/Platform/HelpManager/HelpManager";

export const UserMenuHelpButton: FC = () => {
    const [ show, setShow ] = useState(false);

    const dispatch = useShopfrontDispatch();
    const helpManager = useHelpManager();
    const tinyScreen = useMediaQuery("(max-width: 360px)");

    useEffect(() => {
        const onHelpChange = () => {
            setShow(helpManager.hasSections());
        };

        helpManager.addListener(onHelpChange);

        return () => {
            helpManager.removeListener(onHelpChange);
        };
    }, [ helpManager ]);

    if(!show || !tinyScreen) {
        return null;
    }

    const onClick = (e: MouseEvent<HTMLButtonElement>): void => {
        e.stopPropagation();

        dispatch(showDialog(
            "Help",
            <HelpPage />,
            "information",
            false,
            false,
            true,
            false
        ));
    };

    return (
        <li className="text-xl my-1 truncate w-full">
            <button
                className={
                    "border-0 bg-transparent text-xl py-1 px-0 m-0 inline-block w-full text-left " +
                    "ignore-default text-neutral-900 hover:text-neutral-500 " +
                    "dark:text-neutral-100 dark:hover:text-neutral-400 cursor-pointer min-h-12"
                }
                onClick={onClick}
            >
                <span className="inline-block mr-4 text-primary-dark dark:text-primary">
                    <Icon icon={[ "fal", "question-circle" ]} />
                </span>
                Help Menu
            </button>
        </li>
    );
};
